<template>
  <tbody>
    <tr>
      <td>
        <div>
          {{
            (
              record.personId
                ? (record.retireDate || record.retiredReference.retireDate) : record.lastUpdateDate
            ) | formatDateMMDDYYYY
          }}
        </div>
      </td>
      <td>
        {{ record.lastName }}, {{ record.firstName }}
        <span
          v-if="record.middleName
            && (record.middleName !== '' || record.middleName !== null)"
        >
          {{ record.middleName }}
        </span>
      </td>
      <td>
        {{ displayDOBFormat(record.dateOfBirth) }}
      </td>
      <td>
        {{ getDescriptionFromCode(record.genderCode, activeGenders) }}
      </td>
      <td>
        <es-loader v-if="loading" size="2x" />
        <div v-else>
          <div v-if="record.districtCode">
            <router-link
              :to="{
                name: 'PIDistrictInfoDetails',
                params: {
                  code: record.districtCode
                }
              }"
              class="has-text-weight-bold has-text-primary"
              style="font-size:14px"
            >
              {{ record.district.location.name }}
            </router-link>
            <span
              class="has-text-grey"
              style="padding-left: 0.25rem"
            >
              ({{ record.districtCode }})
            </span>
          </div>
          <div v-else>
            Multiple Districts
          </div>
          <div>
            <div v-if="record.schoolCode">
              <router-link
                :to="{
                  name: 'PISchoolInfoDetails',
                  params: {
                    districtCode: record.districtCode,
                    schoolCode: record.schoolCode,
                  },
                }"
                class="is-italic"
              >
                {{ record.school.location.name }}
              </router-link>
              <span
                class="has-text-grey is-italic"
                style="padding-left: 0.25rem"
              >
                ({{ record.schoolCode }})
              </span>
            </div>
            <div v-else class="has-text-grey is-italic">
                Multiple Schools
            </div>
          </div>
        </div>
      </td>
      <td>
        <span class="retire-id-font">
          {{ formatStateID(record.stateStudentId || record.personId) }}
        </span>
        <span class="retired-font">
          {{ record.personId ? '(Retired)' : '(Active)' }}
        </span>
        <div
          class="max-characters"
        >
          {{
            record.personId
              ? (record.retireReason || record.retiredReference.retireReason) : undefined
          }}
        </div>
      </td>
      <td style="text-align: right">
        <router-link
          v-if="this.activeModule.name === 'personId'"
          :to="{
            name: 'PidAssociatedRecordDetails',
            query: {
              id: record.personId || record.stateStudentId,
              retired: isRetired,
              recordRetired: record.personId ? true : false,
            },
          }"
        >
          <span>
            <font-awesome-icon
              :icon="['far', 'angle-double-right']"
              size="2x"
              title="View Details"
            />
          </span>
        </router-link>
        <router-link
          v-if="this.activeModule.name === 'directMatch'"
          :to="{
            name: 'DmAssociatedRecordDetails',
            query: {
              id: record.personId || record.stateStudentId,
              retired: isRetired,
              recordRetired: record.personId ? true : false,
            },
          }"
        >
          <span>
            <font-awesome-icon
              :icon="['far', 'angle-double-right']"
              size="2x"
              title="View Details"
            />
          </span>
        </router-link>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleRight,
} from '@fortawesome/pro-regular-svg-icons';
import { mapGetters } from 'vuex';
import EsLoader from '@/components/EsLoader.vue';
import StateIdUtils from '@/mixins/StateIdUtils';
import DateUtils from '@/mixins/DateUtils';
import LookupsUtils from '@/mixins/LookupsUtils';

library.add(
  faAngleDoubleRight,
);

export default {
  mixins: [
    StateIdUtils,
    DateUtils,
    LookupsUtils,
  ],
  props: {
    record: {
      type: Object,
      required: true,
    },
    isRetired: {
      type: Boolean,
      default: false,
    },
    isRecordRetired: {
      type: Boolean,
    },
  },
  components: {
    EsLoader,
  },
  data() {
    return {
      loading: false,
      loadingError: false,
    };
  },
  computed: {
    ...mapGetters({
      activeModule: 'appModules/getActiveModule',
    }),
    ...mapGetters('lookups', [
      'activeGenders',
    ]),
  },
};
</script>

<style lang="sass" scoped>
.max-characters
  max-width: 60ch
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis
.retire-id-font
  font-size: 12px
  color: #212529
  font-weight: 700
.retired-font
  color: #737373
</style>
